import { combineReducers } from "redux";

import user from "./user";
import apps from "./apps";
import auth from "./auth";
import appusers from "./appusers";
import customapps from "./customapps";
import organization from "./organization";
import subscriptions from "./subscriptions";
import message from "./message";
import messages from "./messages";
import library from "./library";
import tour from "./tour";
import whiteLabelSettings from "./whiteLabelSettings";
import userActivity from "./userActivity";

const rootReducer = combineReducers({
  user,
  apps,
  auth,
  appusers,
  customapps,
  organization,
  subscriptions,
  message,
  messages,
  library,
  tour,
  whiteLabelSettings,
  userActivity,
});

export default (state, action) =>
  rootReducer(action.type === "LOG_OUT" ? undefined : state, action);



// WEBPACK FOOTER //
// ./src/reducers/index.js